import { render, staticRenderFns } from "./growth-card.vue?vue&type=template&id=400f9990&"
import script from "./growth-card.vue?vue&type=script&lang=js&"
export * from "./growth-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports